

export const baseParksUrl = "https://www.chicagoparkdistrict.com/parks-facilities/"

export const firebaseFunction = "https://us-central1-chicago-beach-poop.cloudfunctions.net/getBeaches";

export const gcpBucket = "https://storage.googleapis.com/chicago-beach-poop-data/beachData.json";

export const oldURL = "https://data.cityofchicago.org/resource/xvsz-3xcj.json?date=2021-07-12";
